import React, { Component } from "react";
import {goodCompany} from './goodCompanyImages';

class DesktopSlider extends Component{

	constructor(props){
		super(props);
		this.state={


		}
	}

	render(){
		return(
				<div className="mobile-scroll">
						<ul>
						  <li>
						    <div className="icon-img">
						      <img src={goodCompany.social_networkers.url} alt={"Social Networkers"}/>
						    </div>
						    <p>Social Networkers</p>
						  </li>
						  <li>
						    <div className="icon-img">
						      <img src={goodCompany.bloggers_vloggers.url} alt={"Bloggers & Vloggers"}/>
						    </div>
						    <p>Bloggers <br/> & Vloggers</p>
						  </li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.journalist_authors.url} alt={"Journalist & Authors"}/>
						  </div>
						  <p>Journalist
						  & Authors</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.photographers_videographers.url} alt={""}/>
						  </div>
						  <p>Photographers <br/>
						  & Videographers</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.models_artists.url} alt={"Models & Artists"}/>
						  </div>
						  <p>Models <br/>
						  & Artists</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.businesses_brands.url} alt={"Businesses & Brands"}/>
						  </div>
						  <p>Businesses <br/>
						  & Brands</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.influencers_entertainers.url} alt={"Influencers & Entertainers"}/>
						  </div>
						  <p>Influencers <br/>
						  & Entertainers</p></li>
						</ul>
			  	</div>
			)
	}
}

export default DesktopSlider;